"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styles = require("./styles");

var _TickIcon = _interopRequireDefault(require("../../../icons/standard-icons/TickIcon"));

var _HyphenIcon = _interopRequireDefault(require("../../../icons/standard-icons/HyphenIcon"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const isCheckable = ({
  type,
  checked
}) => {
  return (type === "radio" || type === "checkbox") && typeof checked === "boolean";
};

const Input = ({
  input,
  className,
  partiallyChecked,
  ...otherProps
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledInputWrapper, {
    inline: otherProps.hasOwnProperty("inline"),
    className: className,
    children: [isCheckable(otherProps) && /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledIconCheckedWrapper, {
      checked: otherProps.checked,
      children: [partiallyChecked && /*#__PURE__*/(0, _jsxRuntime.jsx)(_HyphenIcon.default, {
        title: "Partially checked"
      }), otherProps.checked && !partiallyChecked && /*#__PURE__*/(0, _jsxRuntime.jsx)(_TickIcon.default, {
        title: "Checked"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledInput, { ...input,
      ...otherProps
    })]
  });
};

Input.propTypes = {
  type: _propTypes.default.string,
  input: _propTypes.default.object.isRequired,
  checked: _propTypes.default.bool,
  partiallyChecked: _propTypes.default.bool,
  placeholder: _propTypes.default.string
};
Input.defaultProps = {
  type: "text",
  input: {
    onChange: e => console.log(e.target.value)
  },
  checked: undefined
};
var _default = Input;
exports.default = _default;